/* eslint-disable react/button-has-type */
import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import RawHtml from 'common/RawHtml';
import { withStyles } from 'theme/withStyles';

const styles = ({ spacing }) => ({
  root: {
    padding: [spacing.sm, 0, 0, 0],
  },
});

const BottomContent = ({ children, className, classes, ...props }) => (
  <RawHtml className={classnames(className, classes.root)} {...props}>
    {children}
  </RawHtml>
);

BottomContent.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  theme: PropTypes.shape({}).isRequired,
};

BottomContent.defaultProps = {
  children: null,
  className: '',
};

export default withStyles(styles)(BottomContent);
